import React from "react";
import "./FloatingMenu.scss";
import { NavLink } from "react-router-dom";
import { ReactComponent as Award } from "../../../assets/svg/awards.svg";
import { ReactComponent as Form } from "../../../assets/svg/form.svg";
import { ReactComponent as Home } from "../../../assets/svg/home.svg";
import { ReactComponent as Profile } from "../../../assets/svg/profile.svg";
import { ReactComponent as Simulator } from "../../../assets/svg/simulator.svg";
import { useTranslation } from "react-i18next";

import { useAuthValidation } from "../../../hooks/useAuthValidation";

function FloatingMenu() {
  const { t } = useTranslation();
  const { user, loading } = useAuthValidation(); // Obtém os dados do contexto

  if (loading) {
    return null; // Exibe nada enquanto os dados estão carregando
  }

  if (!user) {
    return null; // Não renderiza o menu se não houver usuário autenticado
  }

  // Identifica o nível do usuário
  const levelId = user.level?.id;
  const roles = user.level?.roles || {};

  let menuItems = [];

  if (levelId === 2) {
    // Promotor
    menuItems = ["home", "profile"];
  } else if (levelId === 3) {
    // Cliente
    menuItems = ["home", "recommendation", "store", "profile"];

    // Se for attendant, adiciona formNF antes de store
    if (roles.attendant) {
      const storeIndex = menuItems.indexOf("store");
      menuItems.splice(storeIndex, 0, "formNF");
    }
  }

  const renderMenuItem = (item) => {
    switch (item) {
      case "home":
        return (
          <li key="home">
            <NavLink to="/home" className={({ isActive }) => (isActive ? "active-link row" : "row")}>
              <Home />
              <span>{t("menu-1")}</span>
            </NavLink>
          </li>
        );
      case "recommendation":
        return (
          <li key="recommendation">
            <NavLink to="/recomendacao" className={({ isActive }) => (isActive ? "active-link row" : "row")}>
              <Simulator />
              <span>{t("menu-3")}</span>
            </NavLink>
          </li>
        );
      case "store":
        return (
          <li key="store">
            <NavLink to="/loja" className={({ isActive }) => (isActive ? "active-link row" : "row")}>
              <Award />
              <span>{t("menu-4")}</span>
            </NavLink>
          </li>
        );
      case "formNF":
        return (
          <li key="formNF">
            <NavLink to="/cadastro-de-nota-fiscal" className={({ isActive }) => (isActive ? "active-link row" : "row")}>
              <Form />
              <span>{t("menu-5")}</span>
            </NavLink>
          </li>
        );
      case "profile":
        return (
          <li key="profile">
            <NavLink to="/perfil" className={({ isActive }) => (isActive ? "active-link row" : "row")}>
              <Profile />
              <span>{t("menu-6")}</span>
            </NavLink>
          </li>
        );
      default:
        return null;
    }
  };

  return (
    <nav className="container">
      <ul className="row">{menuItems.map(renderMenuItem)}</ul>
    </nav>
  );
}

export default FloatingMenu;
